import { palette } from 'src/styles/colors';
import styled from 'styled-components';

export const OverlayVideoBackground = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3;
  background: #0b0b0b;
  opacity: .8;
  overflow: hidden;
  max-width: 100% !important; // used !important to make sure that the background will fill the whole screen
`

export const OverlayVideoContent = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 12;
  height: 56.25vh;
  max-width: 100vw;

  & > div {
    position: absolute;
    right: 0px;
    top: -32px;
    color: ${palette.white};
    font-size: 28px;
    z-index: 10;
    cursor: pointer;
    opacity: 0.8;

    &: hover{
      opacity: 1;
    }
  }
`
export const OverlayVideoPlayer = styled.video`
  max-height: 100%;
  max-width: calc(100vw - 8px);
`
